export const subjectsList = [
  "Allgemeinbildung",
  "Anwendungen der Mathematik",
  "Begabtenförderung",
  "Berufliche Orientierung",
  "Bewegung und Sport",
  "Bildnerisches Gestalten",
  "Biologie",
  "Chemie",
  "Chinesisch",
  "Deutsch",
  "Deutsch als Zweitsprache",
  "Englisch",
  "Ethik, Religionen, Gemeinschaft",
  "Fächerübergreifend",
  "Französisch",
  "Geografie",
  "Geschichte",
  "Griechisch",
  "Hauswirtschaft",
  "Informatik",
  "Italienisch",
  "Klassenstunde, Klassenrat",
  "Latein",
  "Lebenskunde",
  "Mathematik",
  "Medien und Informatik",
  "Musik",
  "Natur und Technik",
  "Natur, Mensch, Gesellschaft",
  "Pädagogik/Psychologie",
  "Philosophie",
  "Physik",
  "Projektunterricht",
  "Räume, Zeiten, Gesellschaften",
  "Religion",
  "Religion, Ethik, Philosophie",
  "Religionen, Kulturen, Ethik",
  "Russisch",
  "Spanisch",
  "Sport",
  "Textiles und technisches Gestalten",
  "Wirtschaft und Recht",
  "Wirtschaft, Arbeit, Haushalt",
  "Anderes",
];
